/*!
 * Lutterloh Unsere Geschichte: Einblenden beim Scrollen, Naht-Fortschritt der Zeitleiste, Reiter im Startseiten-Widget.
 * Vanilla JS ohne Abhängigkeiten, gleiche Muster wie assets/vorfuehrtermine.js,
 * aber eigener Namensraum (window.LutterlohUG). Init idempotent, auch bei shopify:section:load.
 * Ohne JS oder bei reduzierter Bewegung bleibt alles sichtbar und die Naht ist voll genäht.
 */
(function () {
  'use strict';

  if (window.LutterlohUG) {
    window.LutterlohUG.initAll(document);
    return;
  }

  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var hasProp = !!(window.CSS && window.CSS.registerProperty);

  function reduced() { return !!(mqReduce && mqReduce.matches); }
  function toArray(list) { return Array.prototype.slice.call(list || []); }
  function on(el, type, fn, opts, cleanup) {
    if (!el) return;
    el.addEventListener(type, fn, opts || false);
    cleanup.push(function () { el.removeEventListener(type, fn, opts || false); });
  }

  /* ---------- Einblenden ---------- */
  function initReveal(root, cleanup) {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var items = toArray(root.querySelectorAll('.ug-reveal'));
    if (!items.length) return;
    root.classList.add('ug-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
    cleanup.push(function () {
      io.disconnect();
      root.classList.remove('ug-anim');
    });
  }

  /* ---------- Zeitleiste: Faden folgt dem Scrollen, Knöpfe werden angenäht ---------- */
  function initTimeline(root, cleanup) {
    var list = root.querySelector('[data-ug-tl]');
    if (!list || reduced()) return;
    var items = toArray(list.querySelectorAll('[data-ug-ms]'));
    var nodes = items.map(function (li) { return li.querySelector('.ug-ms__node'); });
    if (!items.length || nodes.indexOf(null) > -1) return;
    root.classList.add('ug-tl-live');
    var frame = 0;

    function center(el) {
      var r = el.getBoundingClientRect();
      return r.top + r.height / 2;
    }
    function update() {
      frame = 0;
      var anchor = (window.innerHeight || 800) * 0.62;
      var centers = nodes.map(center);
      items.forEach(function (li, i) {
        li.classList.toggle('is-on', centers[i] <= anchor);
        if (i === items.length - 1) return;
        var span = centers[i + 1] - centers[i];
        var f = span > 0 ? (anchor - centers[i]) / span : 0;
        f = f < 0 ? 0 : (f > 1 ? 1 : f);
        li.style.setProperty('--ug-seg', f.toFixed(3));
      });
    }
    function request() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    on(window, 'scroll', request, { passive: true }, cleanup);
    on(window, 'resize', request, null, cleanup);
    update();
    cleanup.push(function () {
      if (frame) window.cancelAnimationFrame(frame);
      root.classList.remove('ug-tl-live');
      items.forEach(function (li) {
        li.classList.remove('is-on');
        li.style.removeProperty('--ug-seg');
      });
    });
  }

  /* ---------- Sprung zur Zeitleiste mit Fokus auf der Überschrift ---------- */
  function initJump(root, cleanup) {
    toArray(root.querySelectorAll('[data-ug-jump]')).forEach(function (a) {
      on(a, 'click', function (e) {
        var id = (a.getAttribute('href') || '').slice(1);
        var target = id ? document.getElementById(id) : null;
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
        var h = target.querySelector('h2[tabindex]');
        if (h) {
          try { h.focus({ preventScroll: true }); } catch (err) { /* ältere Browser */ }
        }
        if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#' + id);
      }, null, cleanup);
    });
  }

  /* ---------- Startseiten-Widget: Reiter Erklärung und Geschichte ---------- */
  function initTabs(root, cleanup) {
    var list = root.querySelector('[data-ug-tabs]');
    if (!list) return;
    var tabs = toArray(list.querySelectorAll('[role="tab"]'));
    var panes = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    if (!tabs.length || panes.indexOf(null) > -1) return;
    root.classList.add('ug-w--tabs');
    list.hidden = false;
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var active = i === j;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.tabIndex = active ? 0 : -1;
        panes[j].classList.toggle('is-active', active);
        panes[j].setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) panes[j].removeAttribute('inert'); else panes[j].setAttribute('inert', '');
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      on(t, 'click', function () { select(i, false); }, null, cleanup);
      on(t, 'keydown', function (e) {
        var n = tabs.length;
        var to = e.key === 'ArrowRight' ? (i + 1) % n : e.key === 'ArrowLeft' ? (i - 1 + n) % n : e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : -1;
        if (to > -1) { e.preventDefault(); select(to, true); }
      }, null, cleanup);
    });
    select(0, false);
    cleanup.push(function () {
      root.classList.remove('ug-w--tabs');
      list.hidden = true;
      panes.forEach(function (p) { p.classList.remove('is-active'); p.removeAttribute('aria-hidden'); p.removeAttribute('inert'); });
    });
  }

  /* ---------- Start ---------- */
  function init(root) {
    if (root.__ugCleanup) return;
    var cleanup = [];
    if (hasProp) root.classList.add('ug-prop');
    initReveal(root, cleanup);
    initTimeline(root, cleanup);
    initJump(root, cleanup);
    initTabs(root, cleanup);
    root.__ugCleanup = function () {
      cleanup.forEach(function (fn) {
        try { fn(); } catch (err) { /* weiter aufräumen */ }
      });
      root.__ugCleanup = null;
    };
  }
  function destroy(root) {
    if (root.__ugCleanup) root.__ugCleanup();
  }
  function scan(scope, fn) {
    var s = scope || document;
    var sel = '[data-ug-page], [data-ug-widget]';
    var list = s.querySelectorAll ? toArray(s.querySelectorAll(sel)) : [];
    if (s.matches && s.matches(sel)) list.unshift(s);
    list.forEach(fn);
  }
  function initAll(scope) { scan(scope, init); }
  function destroyAll(scope) { scan(scope, destroy); }

  window.LutterlohUG = { initAll: initAll };
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
})();
